import AgentVoiceCapabilitiesChecker from '../configuration/lib/agent_voice_capabilities_checker';
import {
  checkAndResetNavigatingToNext,
  handleNotifiableEvent,
  preloadCustomer,
  removeEmptyQueueNotifications,
} from './lib/conversation_workflow';
import { createAndShowNotification } from 'actions/notification/lib/show_notification';
import ConversationItemType from 'models/conversation_item_type';
import CustomerView from 'models/location/customer_view';
import NavigateToConversation from './navigate_to_conversation';
import RoutingEventType from 'models/routing_event/routing_event_type';
import UpdateAgentTaskRead from 'actions/task/update_agent_task_read';

export default class RoutingEventGatewayObserver {
  constructor(context) {
    this.context = context;
    this.agentVoiceCapabilitiesChecker = new AgentVoiceCapabilitiesChecker(this.context);
  }

  handleRoutingEvent(eventDto) {
    switch (eventDto.type) {
      case RoutingEventType.UNREAD_CONVERSATION:
        this.handleUnreadConversationEvent(eventDto);
        break;
      case RoutingEventType.UNREAD_TASK:
        this.handleUnreadTaskEvent(eventDto);
        break;
      case RoutingEventType.ASSIGNED_CONVERSATION:
        this.handleAssignedConversationEvent(eventDto);
        break;
      case RoutingEventType.ASSIGNED_TASK:
        this.handleAssignedTaskEvent(eventDto);
        break;
      default:
    }
  }

  handleAssignedTaskEvent(eventDto) {
    const resetNavigation = checkAndResetNavigatingToNext(this.context);
    if (this._isViewingCustomer(eventDto.profile.id)) {
      return;
    }
    preloadCustomer(this.context, eventDto.profile.id);
    removeEmptyQueueNotifications(this.context);

    if (resetNavigation) {
      this.context.executeAction(NavigateToConversation, {
        customerId: eventDto.profile.id,
        conversationId: eventDto.conversationId,
        conversationItemId: eventDto.conversationItem.id,
      });
    } else {
      createAndShowNotification(this.context, eventDto);
    }
  }

  handleAssignedConversationEvent(eventDto) {
    if (eventDto.conversationItem && NOTIFIABLE_CONTENT_TYPES.has(eventDto.conversationItem.content.type)) {
      handleNotifiableEvent(this.context, eventDto);
    }
  }

  handleUnreadConversationEvent(eventDto) {
    checkAndResetNavigatingToNext(this.context);

    if (this._isViewingCustomer(eventDto.profile.id)) {
      return;
    }

    preloadCustomer(this.context, eventDto.profile.id);
    removeEmptyQueueNotifications(this.context);

    this.context.executeAction(NavigateToConversation, {
      customerId: eventDto.profile.id,
      conversationId: eventDto.conversationId,
    });
  }

  handleUnreadTaskEvent(eventDto) {
    if (!this._isViewingCustomer(eventDto.profile.id)) {
      preloadCustomer(this.context, eventDto.profile.id);
      removeEmptyQueueNotifications(this.context);
    }

    if (checkAndResetNavigatingToNext(this.context)) {
      this.context.executeAction(UpdateAgentTaskRead, eventDto.conversationItem.id);

      this.context.executeAction(NavigateToConversation, {
        customerId: eventDto.profile.id,
        conversationId: eventDto.conversationId,
        conversationItemId: eventDto.conversationItem.id,
      });
    }
  }

  _isViewingCustomer(customerId) {
    return (
      this.context.stores.currentLocation.get() instanceof CustomerView &&
      this.context.stores.currentLocation.get().customerId === customerId
    );
  }
}

const NOTIFIABLE_CONTENT_TYPES = new Set([
  ConversationItemType.ABANDONED_CALL,
  ConversationItemType.CONVERSATION_NOTE,
  ConversationItemType.EMAIL,
  ConversationItemType.EMAIL_SEND_FAILURE,
  ConversationItemType.FB_MESSAGE_INCOMING,
  ConversationItemType.PHONE_CALL,
  ConversationItemType.SMS,
  ConversationItemType.TASK,
  ConversationItemType.VOICEMAIL,
]);



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation/routing_event_gateway_observer.js